module.exports = __webpack_public_path__ + "static/media/Google_1.d8e1f7bb.png";